export default function localImgLoad(location) {
  const img = require(`../assets/${location}`);
  return img;
}
